<template>
  <div class="medication-administration">
    <v-select
      :disabled="!isEditable"
      :items="items"
      v-model="computedValue"
      outlined
      dense
      hide-details
      class="medication-administration__select"
    >
      <template v-slot:selection="{ item }">
        <v-icon
          class="medication-administration__icon"
          color="#222b45"
        >{{ item.icon }}</v-icon>
      </template>
      <template v-slot:item="{ item }">
        <v-icon
          class="medication-administration__icon"
          color="#222b45"
        >{{ item.icon }}</v-icon>
      </template>
    </v-select>
  </div>
</template>

<script>
import { PILL, INJECTION } from './administration';

/**
 * Component MedicationAdministration.vue
 *
 * @module MedicationAdministration
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.10] app/src/APP_DASHBOARD/templates/components/Parts/Medication/MedicationAdministration.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'MedicationAdministration',
  props: {
    value: {
      type: String,
      required: true,
    },
    isEditable: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      items: [
        {
          icon: 'mdi-pill',
          value: PILL,
        },
        {
          icon: 'mdi-needle',
          value: INJECTION,
        },
      ],
    };
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="scss">
.medication-administration__select {
  width: 80px;
}
</style>
